import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiInputNumberInteger from "../components/Form/UiInputNumberInteger";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiGridForm from "../components/Form/UiGridForm";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function CategoriaForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true, ordem: 0, caracteristicaList: [] }
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputText size={8} name="nome" label="Nome"/>
                        <UiInputNumberInteger size={2} name="ordem" label="Ordem"/>
                        <UiInputCheckbox size={2} name="ativo" label="Ativo"/>
                        <UiInputText size={6} name="slug" label="Slug" placeholder="gerado automaticamente"/>
                        <UiInputSuggest size={6} name="pai" router="categoria" idField="id" titleField="nome" label="Categoria Pai"/>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <fieldset>
                                <legend>Características da Categoria</legend>
                                <div className="row">
                                    <UiGridForm name="caracteristicaList">
                                        <UiInputSuggest size={6} name="caracteristica" router="caracteristica" idField="id" titleField="nome" label="Característica"/>
                                        <UiInputCheckbox size={3} name="obrigatorio" label="Obrigatório"/>
                                        <UiInputNumberInteger size={3} name="ordem" label="Ordem"/>
                                    </UiGridForm>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
